type BottomSheetCloseHandler = () => void;

const closeHandlers: BottomSheetCloseHandler[] = [];

export const registerBottomSheetCloseHandler = (closeHandler: BottomSheetCloseHandler) => {
  closeHandlers.push(closeHandler);

  return () => {
    const closeHandlerIndex = closeHandlers.lastIndexOf(closeHandler);

    if (closeHandlerIndex === -1) {
      return;
    }

    closeHandlers.splice(closeHandlerIndex, 1);
  };
};

export const getActiveBottomSheetCloseHandler = () => closeHandlers.at(-1) ?? null;
